import { render, staticRenderFns } from "./KartuStock.vue?vue&type=template&id=c5e043f8&"
import script from "./KartuStock.vue?vue&type=script&lang=js&"
export * from "./KartuStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "KartuStock.vue"
export default component.exports